module.exports = __webpack_public_path__ + "static/media/euro.ac417f15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/euro.svg
// module id = 803
// module chunks = 0